import React, { forwardRef, useState, useEffect } from "react";
// import "../../components/CommonStyle.css";
// import "./FindMember.css";
import CalendarImg from "../../Images/calendar.png";
import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import InputFieldLargeDisabled from "../StyledComp/InputFieldLargeDisabled";
import MemberServices from "../../services/MemberServices";
import DateFieldLargeDisabled from "../StyledComp/DateFieldLargeDisabled";
import InputFieldSmallDisabled from "../StyledComp/InputFieldSmallDisabled";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import { useDispatch } from "react-redux";
import { changeCurrentMemberMenu } from "../../store/screenSlice";
import { screenConfig } from "../../config/screenConfig";
import { Button, PageLink } from "../StyledComp/StyledComp";
import "../../Styles/memberModal.css";
import MDTagsMultipleOptionItems from "./MDTagsMultipleOptionItems";
import { assignCurrentMember } from "../../store/currentMemberSlice";
import ReactModal from "react-modal";
import MDEditTagsMultipleOptionItems from "./MDEditTagsMultipleOptionItems";
import AlertWithModal from "../utilityComponents/AlertWithModal";

interface MemberCode {
  [key: string]: any;
}
interface Memberype {
  [key: string]: any;
}
interface TagData {
  [key: string]: any;
}

interface IMemberTags {
  Fee: number;
  Id: number;
  Description: string;
  MemberTag: string;
  isSelected: boolean;
  Status: boolean;
}

interface ISelectedMemberTag {
  Id: number | null;
  MemberTag: string | null;
  MemberId: number | null;
}

interface IConfiguration {
  [key: string]: any;
}

const MDMemberTags: React.FC = () => {
  const currentMember = useAppSelector((state) => state.currentMember);
  const selectedTags = currentMember.MemberTags;
  const dispatch = useDispatch();

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");

  const [configurationList, setConfigurationLists] = useState<IConfiguration>(
    {}
  );

  const tagrray = selectedTags?.map((tag: any) => {
    return tag.Id;
  });
  const [selectedItems, setSelectedItems] = useState<
    (number | null)[] | undefined
  >(tagrray);

  const [modalOpen, setModalOpen] = useState(false);
  const roleCapabilites = useAppSelector(
    (state) => state.user.roleCapabilities
  );

  useEffect(() => {
    const getConfigurationLists = async () => {
      const response = await MemberServices.getConfigurationList();
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        setConfigurationLists(response.data.data);
      } else {
      }
    };

    getConfigurationLists();
  }, []);
  const memberTags = configurationList.MemberTag;

  if (typeof memberTags != "undefined") {
    memberTags.map((memberTag: IMemberTags) => {
      const isChecked = (selecedFlag: ISelectedMemberTag) => {
        return selecedFlag.Id === memberTag.Id;
      };

      if (selectedTags?.some(isChecked)) {
        memberTag.isSelected = true;
      } else {
        memberTag.isSelected = false;
      }
    });
  }

  const openMemberEditSectionInfoScreen = () => {
    dispatch(changeCurrentMemberMenu(screenConfig.memberEditMemberTagScreen));
  };

  const handleChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    memberTag: IMemberTags
  ) => {
    if (event.target.checked) {
      console.log("checked");
      setSelectedItems((selectedItems) => [
        ...selectedItems!,
        Number(event.target.id),
      ]);
    } else {
      console.log("un checked");
      setSelectedItems((selectedItems) =>
        selectedItems!.filter((item) => {
          return item !== Number(event.target.id);
        })
      );
    }
    console.log("selectedItems", selectedItems);
  };

  const onSubmit = async (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    console.log("updated Tags:", selectedItems);
    const response = await MemberServices.editMemberTags({
      MemberId: currentMember?.Id,
      Tags: selectedItems,
    });
    console.log("response", response);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      alert("Tags updated  successfully");
      // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
      dispatch(assignCurrentMember(response.data.data[0]));
      // dispatch(changeCurrentMemberMenu(screenConfig.memberDetailScreen));
    } else {
      console.log("error");
    }
    setModalOpen(false);
    // dispatch(changeCurrentMemberMenu(screenConfig.memberDetailScreen));
  };

  const handleEdit = () => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("members.edit")
      )
    ) {
      alert("No Access");
      return;
    }
    setModalOpen(true);
  };

  return (
    <div className="section-box">
      <div className="horizontal-wrapper-spacebetween">
        <h1 className="page-heading">Member Tags</h1>
        <PageLink onClick={() => handleEdit()}>Edit</PageLink>
      </div>
      <div className="form-wrapper">
        {typeof memberTags != "undefined" ? (
          <div className="sections-section overflow-auto">
            {memberTags.map((memberTag: IMemberTags) =>
              memberTag.Status ? (
                <MDTagsMultipleOptionItems
                  key={memberTag.Id}
                  memberTag={memberTag}
                  isSection={true}
                />
              ) : null
            )}
          </div>
        ) : (
          <></>
        )}
      </div>
      <ReactModal
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween ">
          <h1 className="page-heading">Edit Member Tags Information ({currentMember?.FirstName + " " + currentMember?.LastName})</h1>
          <PageLink onClick={() => setModalOpen(false)}>Cancel</PageLink>
        </div>
        <>
          {typeof memberTags != "undefined" ? (
            <div className="sections-section overflow-auto">
              {memberTags.map((memberTag: IMemberTags) => (
                <MDEditTagsMultipleOptionItems
                  memberTag={memberTag}
                  onChangeFunction={handleChange}
                />
              ))}
            </div>
          ) : (
            <></>
          )}
        </>
        <div className="button-wrapper">
          <div className="submit-button-div ">
            <Button type="submit" onClick={onSubmit}>
              Save
            </Button>
          </div>
        </div>
      </ReactModal>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default MDMemberTags;
